import pricingTypes from '../../../../utils/pricing-types';
export const ORDER_DETAILS_TAB_VALUES = {
    overview: 'overview',
    tasksNotes: 'tasks-notes',
    invoices: 'invoices',
    driverTasks: 'driver-tasks',
    contacts: 'contacts',
    costs: 'costs',
    activity: 'activity',
};
export const formatRentalPeriod = (ordRo) => ordRo ? `${ordRo.adjustedRentalPeriod ?? ordRo.originalRentalPeriod ?? '—'} days` : '—';
export const resolveUserDisplayName = (profile, userID, noUserFallback = '—') => {
    if (profile)
        return profile.fullName || `${profile.firstName ?? ''} ${profile.lastName ?? ''}`.trim() || 'System';
    return userID ? 'System' : noUserFallback;
};
export const formatPricingType = (pricingType) => pricingType ? (pricingTypes[pricingType] ?? pricingType) : '—';
//# sourceMappingURL=order-details-constants.js.map